import type { DeclaredNodePayload } from '@Application/Documents/Templates/Actions/documentTemplateVersionFetched';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class DeclaredNodeView {
	readonly uuid: string;
	readonly path: string;
	readonly name: string;
	readonly isList: boolean;
	readonly order: number;

	constructor(payload: DeclaredNodePayload) {
		this.uuid = payload.uuid;
		this.path = payload.path;
		this.name = payload.name;
		this.isList = payload.isList;
		this.order = payload.order;

		Object.freeze(this);
	}
}

export default DeclaredNodeView;
